<template>
	<div class="features-icons">
		<div
			v-for="({ featureName, name, icon, tooltip, size }) in features"
			:key="name"
			class="icon"
		>
			<svg-icon :size="size" :color="color(name)">
				<component :is="icon" />
			</svg-icon>
			<p class="icon__text" :style="{ color: color(name) }">
				{{ featureName }}
			</p>
			<div class="tooltip-container">
				<tooltip>
					<template v-if="includedFeatures[name]">
						{{ tooltip.included }}
					</template>
					<template v-else>
						<p class="tooltip-missing" v-html="tooltip.missing" />
					</template>
				</tooltip>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from "./svg-icon";
import Tooltip from "@c/generals/tooltip";
import _isEmpty from "lodash/isEmpty";

export default {
	components: {
		Tooltip,
		SvgIcon
	},
	props: {
		colors: {
			type: Object,
			default() {
				return {
					included: "#51007A",
					missing: "#9FA9B2"
				};
			}
		},
		buildParts: {
			type: Object,
			default() {
				return {};
			}
		},
		features: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	computed: {
		featuresActive() {
			if (!_isEmpty(this.buildParts)) {
				const motherboardBluetooth = this.buildParts.motherboards.bluetooth === "1";
				const extrasBluetooth = this.buildParts.extras.some(extra => extra.bluetooth === "1");
				const motherboardsWifi = this.buildParts.motherboards.wifi === "1";
				const extrasWifi = this.buildParts.extras.some(extra => extra.wifi === "1");
				const vrReady = this.buildParts.gpus.vr_capable === "1" && this.buildParts.cpus.vr_capable === "1";
				const streamReady = this.buildParts.ram.streaming_ready;
				const usbC = this.buildParts.motherboards.external_usb_type_c === "1";

				return {
					bluetooth: motherboardBluetooth || extrasBluetooth,
					wifi: motherboardsWifi || extrasWifi,
					vrReady,
					usbC,
					streamReady
				};
			}
			return {};
		},
		includedFeatures() {
			if (_isEmpty(this.featuresActive)) {
				return {};
			}

			const compatibility = {
				bluetooth: this.featuresActive.bluetooth,
				rgbLighting: true,
				streamReady: this.featuresActive.streamReady,
				usbC: this.featuresActive.usbC,
				vrReady: this.featuresActive.vrReady,
				wifi: this.featuresActive.wifi
			};

			return compatibility;
		}
	},
	methods: {
		color(name) {
			return this.includedFeatures[name] ? this.colors.included : this.colors.missing;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.icon svg:hover + .tooltip-container {
	display: block;
}

.tooltip-container {
	position: absolute;
	display: none;
}

.icon:hover {
	.tooltip-container {
	display: block;
	}
}

.features-icons::v-deep {
	.help-tooltip {
		min-width: auto;
		padding: 15px;
		transform: translate(-95%, -150%) !important;
		text-align: left;

		.tooltip-missing {
			margin: 0;
			span {
				font-size: 16px;
				color: #BF4CBF;
				font-family: 'Akkurat-Bold';
			}
		}
	}
}
</style>